function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0313 12.9548C22.9948 10.7116 25.0023 8.95935 27.5745 8.42733C31.7575 7.56212 35.8499 10.2517 36.7151 14.4348C37.3232 17.3746 36.1754 20.2697 33.9874 22.0312",
  stroke: "#F0F0F5",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 41.9929,
  y1: 13.6463,
  x2: 39.8202,
  y2: 14.0957,
  stroke: "#F25022",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 18.5821,
  y1: 18.4886,
  x2: 16.4093,
  y2: 18.938,
  stroke: "#F25022",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 41.9929,
  y1: 13.6463,
  x2: 39.8202,
  y2: 14.0957,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 18.5821,
  y1: 18.4886,
  x2: 16.4093,
  y2: 18.938,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip4)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 41.4486,
  y1: 20.3878,
  x2: 39.3423,
  y2: 19.6906,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip5)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 21.7077,
  y1: 8.10075,
  x2: 20.2322,
  y2: 6.44379,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip6)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 26.654,
  y1: 5.44258,
  x2: 26.2046,
  y2: 3.26982,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip7)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 32.2665,
  y1: 5.6136,
  x2: 32.9637,
  y2: 3.50723,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip8)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 37.0415,
  y1: 8.56807,
  x2: 38.6985,
  y2: 7.09249,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0264 14.5772C35.2399 10.7745 31.5195 8.32935 27.7167 9.1159C25.6033 9.55303 23.9093 10.8963 22.9562 12.6562C24.2104 12.8125 27.1876 13.6875 29.0626 15.9375C30.9376 18.1875 31.4063 20.625 31.4063 21.5625L32.8125 22.0001C35.2704 20.4956 36.6437 17.5618 36.0264 14.5772Z",
  fill: "#FFB900"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.1995 20.331C31.1995 20.331 31.3722 21.1818 31.4312 21.19C34.6128 21.6299 37 23.4295 37 26.6364C37 30.1509 34.0619 33 30.4375 33H13.5625C9.93813 33 7 30.1509 7 26.6364C7 23.4295 9.44615 20.7767 12.6278 20.3368C12.6867 20.3286 12.7445 20.3269 12.8005 20.331C13.6458 16.1525 17.4433 13 22 13C26.5567 13 30.3542 16.1525 31.1995 20.331Z",
  stroke: "#F0F0F5",
  strokeWidth: 2
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 37.8074,
  y: 12.7729,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(-11.6862 37.8074 12.7729)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16.1719,
  y: 14.5312,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 37.8074,
  y: 12.7729,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(-11.6862 37.8074 12.7729)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16.1719,
  y: 14.5312,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 38.2606,
  y: 17.5385,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(18.3138 38.2606 17.5385)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip5"
}, /*#__PURE__*/React.createElement("rect", {
  x: 20.3714,
  y: 4.03925,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(48.3138 20.3714 4.03925)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 27.5274,
  y: 1.25702,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(78.3138 27.5274 1.25702)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip7"
}, /*#__PURE__*/React.createElement("rect", {
  x: 35.1157,
  y: 2.42554,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(108.314 35.1157 2.42554)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip8"
}, /*#__PURE__*/React.createElement("rect", {
  x: 41.1031,
  y: 7.23172,
  width: 5.625,
  height: 2.8125,
  rx: 1.40625,
  transform: "rotate(138.314 41.1031 7.23172)",
  fill: "white"
})));

function SvgMostlyCloudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostlyCloudy);
export default __webpack_public_path__ + "static/media/mostly-cloudy.ff18f360.svg";
export { ForwardRef as ReactComponent };